export { EmojiComponent } from './emoji.component';
